import { saveReferralIdMapping } from '@getvim/vim-connect/src/infra/common/api/referral/referral-id-mapping';
import { ReferralExternalIdSource } from '@getvim/platform-types';
import { EnrichedReferral } from '@getvim-os/types';
import { internalApi } from '../../api';
import { createLogger } from '../../utils';

const logger = createLogger('referralSaved');

const sendReferralSavedToOptum = async ({
  referral,
  currentReferralOptumId,
  optumDeployConfiguration,
}: {
  referral: EnrichedReferral;
  currentReferralOptumId: string | undefined;
  optumDeployConfiguration: string;
}) => {
  const { referralId } = referral ?? {};
  const referralEhrId = referralId?.toString();
  logger.info('Starting sendReferralSavedToOptum', {
    referralId: referralEhrId,
    currentReferralOptumId,
    noPHI: true,
  });
  if (!referralEhrId || !currentReferralOptumId) {
    logger.warning("referral didn't send to optum, we dont have referralId or optumReferralId", {
      referralId: referralEhrId,
      currentReferralOptumId,
      noPHI: true,
    });
    return;
  }

  try {
    await saveReferralIdMapping({
      ehrId: referralEhrId,
      externalId: currentReferralOptumId,
      source: ReferralExternalIdSource.OPTUM,
    });
    logger.info('saveReferralIdMapping request succeeded', {
      referralId: referralEhrId,
      currentReferralOptumId,
      noPHI: true,
    });
    await internalApi.optumNoPIIApi.sendReferralSaveInEhr({
      referralId: currentReferralOptumId,
      referralEhrId,
      deployConfig: optumDeployConfiguration,
    });
    logger.info('sendReferralSaveInEhr request succeeded', {
      referralId: referralEhrId,
      currentReferralOptumId,
      noPHI: true,
    });
  } catch (error) {
    logger.error('sendReferralSaveInEhr request failed', {
      referralId: currentReferralOptumId,
      referralEhrId,
      err: error,
      noPHI: true,
    });
  }
};

export { sendReferralSavedToOptum };
